import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconImport: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16732 3.3335H15.834C16.2923 3.3335 16.6673 3.7085 16.6673 4.16683V5.8335C16.6673 6.29183 16.2923 6.66683 15.834 6.66683C15.3757 6.66683 15.0007 6.29183 15.0007 5.8335V5.00016H5.00065V5.8335C5.00065 6.29183 4.62565 6.66683 4.16732 6.66683C3.70898 6.66683 3.33398 6.29183 3.33398 5.8335V4.16683C3.33398 3.7085 3.70898 3.3335 4.16732 3.3335ZM6.66817 11.6668C6.414 11.6668 6.16484 11.5518 6.00067 11.3335C5.724 10.9652 5.799 10.4427 6.16734 10.1668L9.50067 7.66683C9.789 7.45016 10.1857 7.44433 10.4798 7.65183L13.8132 9.99683C14.1898 10.2618 14.2807 10.7818 14.0157 11.1577C13.7507 11.5335 13.2315 11.6252 12.8548 11.3602L10.8316 9.9369C10.8332 9.95779 10.834 9.97888 10.834 10.0002V16.6668C10.834 17.1268 10.4615 17.5002 10.0007 17.5002C9.53982 17.5002 9.16732 17.1268 9.16732 16.6668V10.0003L7.16734 11.5002C7.01734 11.6127 6.84234 11.6668 6.66817 11.6668Z"
        fill={fill}
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="3"
        y="3"
        width="14"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.16732 3.3335H15.834C16.2923 3.3335 16.6673 3.7085 16.6673 4.16683V5.8335C16.6673 6.29183 16.2923 6.66683 15.834 6.66683C15.3757 6.66683 15.0007 6.29183 15.0007 5.8335V5.00016H5.00065V5.8335C5.00065 6.29183 4.62565 6.66683 4.16732 6.66683C3.70898 6.66683 3.33398 6.29183 3.33398 5.8335V4.16683C3.33398 3.7085 3.70898 3.3335 4.16732 3.3335ZM6.66817 11.6668C6.414 11.6668 6.16484 11.5518 6.00067 11.3335C5.724 10.9652 5.799 10.4427 6.16734 10.1668L9.50067 7.66683C9.789 7.45016 10.1857 7.44433 10.4798 7.65183L13.8132 9.99683C14.1898 10.2618 14.2807 10.7818 14.0157 11.1577C13.7507 11.5335 13.2315 11.6252 12.8548 11.3602L10.8316 9.9369C10.8332 9.95779 10.834 9.97888 10.834 10.0002V16.6668C10.834 17.1268 10.4615 17.5002 10.0007 17.5002C9.53982 17.5002 9.16732 17.1268 9.16732 16.6668V10.0003L7.16734 11.5002C7.01734 11.6127 6.84234 11.6668 6.66817 11.6668Z"
          fill={fill}
        />
      </mask>
    </Icon>
  );
};

export default IconImport;
